import { jsx } from "react/jsx-runtime";
import { useState } from "react";
const FallbackImage = ({ fallbackImage, src, ...props }) => {
  const [fallbackImgSrc, setFallbackImgSrc] = useState(void 0);
  const imgSrc = fallbackImgSrc || src;
  return /* @__PURE__ */ jsx("img", { ...props, onError: () => setFallbackImgSrc(fallbackImage), src: imgSrc });
};
export {
  FallbackImage
};
//# sourceMappingURL=FallbackImage.js.map
